// extracted by mini-css-extract-plugin
module.exports = {"quizz":"SkillsMapping_quizz__uRA9X"};